import React, { useEffect, useState } from 'react';
import Item from './Item'

const AppointmentPicker = ({ patientAppointments = null, selectedAppointment, setSelectedAppointment }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  useEffect(() => {
    if (patientAppointments)
      setSelectedAppointment(patientAppointments[0])

  }, [patientAppointments])

  if (!patientAppointments)
    return (
      <div className="border border-slate-100 rounded-lg p-4 bg-white shadow-sm space-y-3 cursor-pointer hover:border-slate-200 hover:shadow transition-all duration-200 flex flex-col relative" >
        <div className='flex justify-between'>
          <div className="skeleton h-4 w-2/5"></div>
          <div className="skeleton h-4 w-1/5"></div>
        </div>
        <div className="skeleton h-3 w-2/6"></div>
        <div className="skeleton h-4 w-3/5"></div>
      </div>
    )

  if (patientAppointments.length === 0)
    return <div className="py-6 text-center font-semibold text-sm text-secondary-400">No Appointments Found</div>

  return (
    <div className="relative">
      <Item
        item={selectedAppointment}
        isDropdownOpen={isDropdownOpen}
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      />

      {isDropdownOpen && (
        <div className="absolute z-10 left-0 right-0 mt-1 bg-white border border-slate-200 rounded-lg shadow-lg overflow-hidden max-h-[220px] overflow-y-auto divide-y divide-slate-100">
          {patientAppointments.map((item) => (
            <Item
              key={item.id}
              item={item}
              isDropdownOpen={isDropdownOpen}
              onClick={() => { setSelectedAppointment(item); setIsDropdownOpen(false) }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AppointmentPicker;
